import React from 'react';
import {
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
  IonGrid, IonRow, IonCol, IonCard, IonCardContent,
  IonFab, IonFabButton, IonIcon, IonSpinner,
} from '@ionic/react';
import { add, albums, settingsOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import { useBinders } from '../hooks/useBinders';

const BinderList: React.FC = () => {
  const { data: binders, isLoading } = useBinders();
  const history = useHistory();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary" style={{ position: 'relative' }}>
          <IonTitle>Binders</IonTitle>
          <IonIcon
            icon={settingsOutline}
            onClick={() => history.push('/settings')}
            style={{ position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)', fontSize: 24, cursor: 'pointer', color: '#fff', zIndex: 10 }}
          />
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        {isLoading ? (
          <div className="ion-text-center"><IonSpinner /></div>
        ) : binders && binders.length > 0 ? (
          <IonGrid>
            <IonRow>
              {binders.map((binder) => (
                <IonCol size="6" sizeMd="4" sizeLg="3" key={binder.id}>
                  <IonCard
                    button
                    onClick={() => history.push(`/binders/${binder.id}`)}
                    style={{ borderTop: `4px solid ${binder.color}` }}
                  >
                    <IonCardContent style={{ textAlign: 'center' }}>
                      <IonIcon icon={albums} style={{ fontSize: 48, color: binder.color }} />
                      <h2 style={{ margin: '8px 0 4px', fontWeight: 'bold' }}>{binder.name}</h2>
                      <p>{binder.card_count} cards</p>
                      <p style={{ color: '#2dd36f', fontWeight: 'bold' }}>${binder.total_value.toFixed(2)}</p>
                    </IonCardContent>
                  </IonCard>
                </IonCol>
              ))}
            </IonRow>
          </IonGrid>
        ) : (
          <div className="ion-text-center ion-padding">
            <p>No binders yet. Create one to organize your cards!</p>
          </div>
        )}

        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton onClick={() => history.push('/binders/new/edit')}>
            <IonIcon icon={add} />
          </IonFabButton>
        </IonFab>
      </IonContent>
    </IonPage>
  );
};

export default BinderList;
